import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["className"],
      _excluded2 = ["className"],
      _excluded3 = ["className"],
      _excluded4 = ["className"],
      _excluded5 = ["className"],
      _excluded6 = ["className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import { cn } from '@/shadcn/lib/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const Card = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx("div", _objectSpread({
    ref: ref,
    className: cn('rounded-lg border border-neutral-200 bg-white text-neutral-950 shadow-sm dark:border-neutral-800 dark:bg-neutral-950 dark:text-neutral-50', className ?? '')
  }, props));
});
Card.displayName = 'Card';
const CardHeader = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className
  } = _ref2,
      props = _objectWithoutProperties(_ref2, _excluded2);

  return /*#__PURE__*/_jsx("div", _objectSpread({
    ref: ref,
    className: cn('flex flex-col space-y-1.5 p-6', className ?? '')
  }, props));
});
CardHeader.displayName = 'CardHeader';
const CardTitle = /*#__PURE__*/React.forwardRef((_ref3, ref) => {
  let {
    className
  } = _ref3,
      props = _objectWithoutProperties(_ref3, _excluded3);

  return /*#__PURE__*/_jsx("h3", _objectSpread({
    ref: ref,
    className: cn('text-2xl font-semibold leading-none tracking-tight', className ?? '')
  }, props));
});
CardTitle.displayName = 'CardTitle';
const CardDescription = /*#__PURE__*/React.forwardRef((_ref4, ref) => {
  let {
    className
  } = _ref4,
      props = _objectWithoutProperties(_ref4, _excluded4);

  return /*#__PURE__*/_jsx("p", _objectSpread({
    ref: ref,
    className: cn('text-sm text-neutral-500 dark:text-neutral-400', className ?? '')
  }, props));
});
CardDescription.displayName = 'CardDescription';
const CardContent = /*#__PURE__*/React.forwardRef((_ref5, ref) => {
  let {
    className
  } = _ref5,
      props = _objectWithoutProperties(_ref5, _excluded5);

  return /*#__PURE__*/_jsx("div", _objectSpread({
    ref: ref,
    className: cn('p-6 pt-0', className ?? '')
  }, props));
});
CardContent.displayName = 'CardContent';
const CardFooter = /*#__PURE__*/React.forwardRef((_ref6, ref) => {
  let {
    className
  } = _ref6,
      props = _objectWithoutProperties(_ref6, _excluded6);

  return /*#__PURE__*/_jsx("div", _objectSpread({
    ref: ref,
    className: cn('flex items-center p-6 pt-0', className ?? '')
  }, props));
});
CardFooter.displayName = 'CardFooter';
export { Card, CardHeader, CardFooter, CardTitle, CardDescription, CardContent };